'use client';
import { sendEvent, sendEventProps } from '../newRelic';

export const SendNavigatorData = ({
  app,
  instanceType,
}: {
  app: sendEventProps['app'];
  instanceType?: sendEventProps['instanceType'];
}) => {
  const screenSize = `${window.screen.width}x${window.screen.height}`;
  const memory = (navigator as any)?.deviceMemory || 0;
  const platform = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ? 'mobile'
    : 'desktop';
  sendEvent({
    app,
    instanceType,
    type: 'stat',
    data: { userAgent: navigator.userAgent, screenSize, memory, platform },
  });
};
